export enum TicketType {
  Operator = 'operator',
  SymptomOperator = 'symptomOperator',
  Patient = 'patient',
  CallbackRequest = 'callbackRequest',
  Task = 'task',
  Overdue = 'overdue'
}
